import { Society, SocietyDirector } from 'types';

export const getDirectorDetailsUrl = (
  director: SocietyDirector,
  society: Society
): string =>
  director && society ? `/detalle-miembro/${society._id}/${director._id}` : '';
